import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-simple-check-modal',
  imports: [CommonModule],
  standalone: true,
  template: `
    <div
      class="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        @opacity
        *ngIf="isModal"
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          *ngIf="isModal"
          (click)="toggleModal()"
          class="fixed inset-0 pointer-events-none"
        ></div>
        <div
          class="flex min-h-full items-center justify-center p-4 text-center sm:p-0"
        >
          >
          <div
            @opacityTranslateY
            *ngIf="isModal"
            class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
          >
            <div>
              <div class="mt-3 text-center sm:mt-5">
                <h3
                  class="text-base font-semibold leading-6 text-gray-900"
                  id="modal-title"
                >
                  {{ title }}
                </h3>
                <div class="mt-2">
                  <p class="text-sm text-gray-500" [innerHTML]="message"></p>
                </div>
              </div>
            </div>
            <div
              class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3"
            >
              <button
                type="button"
                (click)="
                  onSendValue(true);
                  $event.stopPropagation();
                  $event.preventDefault()
                "
                class="inline-flex w-full justify-center rounded-md bg-columbus-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-columbus-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-columbus-blue-600 sm:col-start-2"
              >
                {{ positiveButtonText }}
              </button>
              <button
                type="button"
                (click)="
                  onSendValue(false);
                  $event.stopPropagation();
                  $event.preventDefault()
                "
                class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
              >
                {{ negativeButtonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: ``,
  animations: [
    trigger('opacity', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('200ms ease-in', style({ opacity: 0 })),
      ]),
    ]),
    trigger('opacityTranslateY', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(1rem)' }),
        animate(
          '300ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' }),
        ),
      ]),
      transition(':leave', [
        style({ opacity: 1, transform: 'translateY(0)' }),
        animate(
          '200ms ease-in',
          style({ opacity: 0, transform: 'translateY(1rem)' }),
        ),
      ]),
    ]),
  ],
})
export class SimpleCheckModalComponent {
  @Input() title?: string;
  @Input() message?: string;
  @Input() positiveButtonText?: string;
  @Input() negativeButtonText?: string;
  @Output() close = new EventEmitter<boolean>();
  isModal = true;

  toggleModal() {
    this.isModal = !this.isModal;
  }

  onSendValue(value: boolean) {
    this.close.emit(value);
  }
}
